import { createAction, props } from '@ngrx/store';
import { ContentBlock } from '../../models';

export const LoadContentBlocks = createAction('[Content] Load Content Blocks', props<{ pageId: number }>());
export const LoadContentBlocksSuccess = createAction(
  '[Content] Load Content Blocks Success',
  props<{ pageId: number; contentBlocks: ContentBlock[] }>()
);
export const LoadContentBlocksFail = createAction('[Content] Load Content Blocks Fail', props<{ pageId: number; error: any }>());
